import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, DropdownToggle, DropdownItem } from 'reactstrap';
import {
	AccountCircle,
	LockOutlined,
	ExitToAppOutlined,
	AccountCircleOutlined,
	DensitySmall
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import * as ActionsAuth from '~/store/modules/auth/actions';
import ReactGA from 'react-ga4';
import { Profile, Picture, DropdownMenuStyled } from '../styles';

import { ModalDoc } from '../../../views/Client/Dashboard/Modais/ModalDoc';

function Perfil({color = 'black', dropdownOpen = false, setDropdownOpen}) {
	const { user } = useSelector((state) => state.auth);
	const dispatch = useDispatch();

	const toggle = () => setDropdownOpen((prevState) => !prevState);

	function handlerSair() {
		dispatch(ActionsAuth.signOut(user));
		handleClickLogoutGA4();
	}

	const [modalDetalheVenda, setModalDetalheVenda] = useState(false);

	function handleClickTermoEContratoGA4() {
		ReactGA.event({
			category: "termo_contrato_click",
			action: "Termos e Contratos",
			label: "Acesso aos Termos e Contratos",
		});
	}

	const toggleModalDetalheVenda = useCallback(() => {
		handleClickTermoEContratoGA4();
		setModalDetalheVenda((oldValue) => !oldValue);
	}, []);

	function handleClickLogoutGA4() {
		ReactGA.event({
			category: "logout_click",
			action: "Logout Portal",
			label: "Saindo do Portal",
		});
	}

	return (
		<Dropdown isOpen={dropdownOpen} toggle={toggle}>
			<DropdownToggle
				tag="span"
				style={{ cursor: 'pointer' }}
				data-toggle="dropdown"
				aria-expanded={dropdownOpen}>
				<AccountCircleOutlined style={{color: color}} />
			</DropdownToggle>
			<DropdownMenuStyled className="fullscreen-dropdown" right>
				<Profile>
					<Picture>
						<AccountCircle />
					</Picture>
					<p>{user.dados.nome}</p>
					<div>{user.dados.email}</div>
				</Profile>
				<DropdownItem className="fullscreen-dropdownItem">
					<Link to="/client/alterar-senha">
						<LockOutlined className="mr-1" />
						<span>Alterar minha senha</span>
					</Link>
				</DropdownItem>
				<DropdownItem className="fullscreen-dropdownItem">
					<Link to="/client/dashboard" onClick={toggleModalDetalheVenda}>
						<DensitySmall className="mr-1" />
						<span>Termos e contratos</span>
					</Link>
				</DropdownItem>
				<DropdownItem divider />
				<DropdownItem className="fullscreen-dropdownSair" onClick={() => handlerSair()}>
					<ExitToAppOutlined className="mr-1 exit-icon" />
					Sair
				</DropdownItem>
			</DropdownMenuStyled>
			<ModalDoc
				toggle={toggleModalDetalheVenda}
				isOpen={modalDetalheVenda}
			/>
		</Dropdown>
	);
}

export default Perfil;
